import { SettingGroup } from "../types"
import { SettingStore } from "~models/setting-store"
import { WalletStore } from "~models/wallet-store"
import { getDndTimeSlotLabel } from "../dnd-time-slot-options"

type MessageSchemaDeps = {
  settingStore: SettingStore
  walletStore: WalletStore
}
export const messageSchema = ({
  settingStore,
  walletStore
}: MessageSchemaDeps): SettingGroup[] => [
    {
        title: "通知设置",
        contents: [
            {
                id: "message.messageNotify",
                type: "switch",
                title: "消息通知",
                content: "接受新消息时显示通知",
                suffix: {
                    type: "switch",
                    value: walletStore.msg_notify_enabled,
                    onChange: settingStore.setMessageNotify,
                },
                icon: "xxtz",
                iconColor: "#07c160",
                iconSize: 16,
                bg: "rgba(7, 193, 96, 0.1)",
            },
            {
                id: "message.notifyPreview",
                type: "switch",
                title: "通知预览",
                content: "在通知中显示消息内容",
                suffix: {
                    type: "switch",
                    value: walletStore.msg_preview_enabled,
                    onChange: settingStore.setNotifyPreview,
                },
                icon: "gensuixitong",
                iconColor: "#07c160",
                iconSize: 16,
                bg: "rgba(7, 193, 96, 0.1)",
            },
            {
                id: "message.groupNotify",
                type: "switch",
                title: "群聊通知",
                content: "接受群聊消息通知",
                suffix: {
                    type: "switch",
                    value: walletStore.group_notify_enabled,
                    onChange: settingStore.setGroupNotify,
                },
                icon: "qlltz",
                iconColor: "#07c160",
                iconSize: 16,
                bg: "rgba(7, 193, 96, 0.1)",
            },
            {
                id: "message.channelNotify",
                type: "switch",
                title: "频道通知",
                content: "接受频道消息通知",
                suffix: {
                    type: "switch",
                    value: walletStore.channel_notify_enabled,
                    onChange: settingStore.setChannelNotify,
                },
                icon: "pdtz",
                iconColor: "#07c160",
                iconSize: 16,
                bg: "rgba(7, 193, 96, 0.1)",
            },
        ]
    },
    // {
    //     title: "声音与振动",
    //     contents: [
    //         {
    //             id: "message.notificationBell",
    //             type: "navigate",
    //             title: "通知铃声",
    //             content: "设置消息通知铃声",
    //             suffix: {
    //                 type: "text",
    //                 value: "默认",
    //             },
    //             icon: "tzls",
    //             iconColor: "#4e98f3",
    //             iconSize: 16,
    //             bg: "rgba(78, 152, 243, 0.1)",
    //         },
    //         {
    //             id: "message.notificationSound",
    //             type: "switch",
    //             title: "声音通知",
    //             content: "接收消息时播放提示音",
    //             suffix: {
    //                 type: "switch",
    //                 value: walletStore.sound_enabled,
    //                 onChange: settingStore.setSoundNotify,
    //             },
    //             icon: "sytz",
    //             iconColor: "#4e98f3",
    //             iconSize: 16,
    //             bg: "rgba(78, 152, 243, 0.1)",
    //         },
    //         {
    //             id: "message.vibrationAlert",
    //             type: "switch",
    //             title: "震动提醒",
    //             content: "接收消息时振动提醒",
    //             suffix: {
    //                 type: "switch",
    //                 value: walletStore.vibrate_enabled,
    //                 onChange: settingStore.setVibrationNotify,
    //             },
    //             icon: "zdtx",
    //             iconColor: "#4e98f3",
    //             iconSize: 16,
    //             bg: "rgba(78, 152, 243, 0.1)",
    //         },
    //     ]
    // },
    {
        title: "免打扰模式",
        contents: [
            {
                id: "message.doNotDisturb",
                type: "switch",
                title: "免打扰模式",
                content: "开启后将不会收到通知",
                suffix: {
                    type: "switch",
                    value: walletStore.dnd_enabled,
                    onChange: settingStore.setDoNotDisturb,
                },
                icon: "mdr",
                iconColor: "#c332d0",
                iconSize: 16,
                bg: "rgba(195, 50, 208, 0.1)",
            },
            {
                id: "message.doNotDisturbTime",
                type: "navigate",
                title: "免打扰时间",
                content: "设置免打扰时间段",
                suffix: {
                    type: "text",
                    value: walletStore.dnd_enabled
                      ? getDndTimeSlotLabel(walletStore.dnd_time_slot ?? 1)
                      : "未启用",
                },
                icon: "sssj",
                iconColor: "#c922c4",
                iconSize: 16,
                bg: "rgba(201, 34, 196, 0.1)",
            }
        ]
    }
]
